import React, { FC } from "react";
import Grid from "@mui/material/Grid";
import GenInputLabel from "../GenInputLabel/GenInputLabel";

export interface GenInputColumnProps {
  label?: string;
  error?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  children: React.ReactNode;
}

const GenInputColumn: FC<GenInputColumnProps> = (props) => {
  const { label, error, required, fullWidth, children } = props;
  return (
    <Grid item md={fullWidth ? 12 : 3} xs={12}>
      {label ? (
        <GenInputLabel fullwidth error={error} required={required}>
          {label}
        </GenInputLabel>
      ) : null}
      {children}
    </Grid>
  );
};

export default GenInputColumn;
